import React, { useState } from 'react';
import { MdClose } from '@react-icons/all-files/md/MdClose';
import PropTypes from 'prop-types';
import { getUrl } from 'gatsby-core-theme/src/helpers/getters';
import Button from './toggle-button/index';
import useTranslate from '~hooks/useTranslate/useTranslate';
import NewsletterForm from './form/index';
import styles from './newsletter.module.scss';

const Newsletter = ({
  page,
  openBtnText = 'Unlock Bonuses',
  isSticky = false,
  showLabels = true,
  titleType = 'h2',
}) => {
  const [toggleNewsetter, setToggleNewsletter] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const country = page?.market?.split('_')[0].toUpperCase();
  const newsletterOpenBtn = useTranslate('newsletter_open_btn', openBtnText)

  const redirectUrl =
    page?.path === '/'
      ? `${getUrl(page?.path)}?subscribed=true`
      : `${getUrl(page?.path)}/?subscribed=true`;

  const statesCombined = () => {
    setToggleNewsletter(!toggleNewsetter);
    setIsClicked(true);
  };

  return (
    <>
      {toggleNewsetter && (
        <div
          className={styles?.layer || '' }
          onClick={() => setToggleNewsletter(false)}
          aria-hidden="true"
        />
      )}
      <div className={!isSticky ? styles.contentPage || '' : styles.content || ''}>
        {isSticky && (
          <Button
            active={!toggleNewsetter}
            text={newsletterOpenBtn}
            toggleNewsLetter={statesCombined}
            isClicked={isClicked}
            gtmClass="newsletter-gtm btn-cta"
          />
        )}
        <div
          className={
            !isSticky
              ? styles?.formPage || ''
              : `${styles?.form || ''} ${toggleNewsetter ? styles?.active || '' : ''}`
          }
        >
          <NewsletterForm
            country={country}
            market={page?.market}
            path={page?.path}
            redirectUrl={redirectUrl}
            showLabels={showLabels}
            titleType={titleType}
          />
          {isSticky && (
            <MdClose
              className={styles?.closeBtn || ''}
              onClick={() => setToggleNewsletter(false)}
              title="Close Icon"
            />
          )}
        </div>
      </div>
    </>
  );
};

Newsletter.propTypes = {
  openBtnText: PropTypes.string,
  page: PropTypes.shape({
    path: PropTypes.string,
    template: PropTypes.string,
    type: PropTypes.string,
    market: PropTypes.string,
  }),
  isSticky: PropTypes.bool,
  showLabels: PropTypes.bool,
  titleType: PropTypes.string,
};

export default Newsletter;
